<template>
    <div>
        <md-field md-inline>
            <label>输入起始序列号</label>
            <md-input v-model="snStart"></md-input>
        </md-field>

        <md-field>
            <label>输入生成数量</label>
            <md-input v-model="snNeedLNumber" type="number"></md-input>
        </md-field>
        <md-button class="md-raised md-primary" @click="genExcel">生成</md-button>

        <md-dialog :md-active.sync="loading" :md-close-on-esc=false :md-click-outside-to-close=false>
            <div class="md-layout md-alignment-center-center" id="loading_content">
                <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
            </div>
        </md-dialog>

        <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>
    </div>
</template>

<script>
    export default {
        name: "ExcelGen",
        data: () => ({
            snStart: '',
            snNeedLNumber: 0,
            loading: false,
            toast: false,
            toastMsg: "",
        }),
        methods: {
            genExcel: function () {
                let reg_name = /[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}:[A-F\d]{2}/;
                if (!reg_name.test(this.snStart)) {
                    this.showErrorTips('格式不正确');
                    return;
                }
                if (parseInt(this.snNeedLNumber) > 10000) {
                    this.showErrorTips('每次生成不能超过10000个');
                    return;
                }
                this.loading = true;
                let _this = this;
                this.$http.get('/api/device/excel/' + this.snStart + "/" + this.snNeedLNumber + '/', {responseType: 'blob'}).then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;

                            let ct = response.headers['content-type']
                            if (ct === 'application/json') {
                                this.loading = false;
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    default:
                                        this.showErrorTips('获取失败，服务器返回错误码' + data.code);
                                        break
                                }
                            } else {
                                let reader = new FileReader();
                                reader.readAsDataURL(data);
                                reader.onload = function (e) {
                                    _this.loading = false;
                                    let a = document.createElement('a');
                                    let fileName = response.headers["content-disposition"].split("=");
                                    fileName = fileName[fileName.length - 1];
                                    fileName = fileName.replace(/"/g, "");
                                    a.download = fileName;
                                    a.href = e.target.result;
                                    document.body.appendChild(a);
                                    a.click();
                                    document.body.removeChild(a);
                                }
                            }
                        } else {
                            _this.loading = false;
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.loading = false;
                    if (error.response.status === 403) {
                        localStorage.clear();
                        this.$router.replace('/login')
                    } else {
                        this.showErrorTips('未知错误' + error);
                    }
                })
            },
            showTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
            showErrorTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
        },
    }
</script>

<style scoped>
    #loading_content {
        padding: 50px 0;
    }
</style>